import * as ko from 'knockout';
import * as _ from "underscore";

// Helpers
import "selectTwoBindingConfig";
import "knockoutCustomBindings";

// Models
import { IClubSelectionParams } from "Content/ts/Models/Shared/ClubSelector/IClubSelectionParams";
import { ClubSelectionBase } from "Content/ts/Shared/ClubSelector/ClubSelectionBase";

export default class SingleClubSelection extends ClubSelectionBase {
    constructor(params: IClubSelectionParams) {
        super(params);
    };
}

const componentName = "single-club-selection";
ko.components.unregister(componentName);
ko.components.register(componentName, {
    viewModel: SingleClubSelection,
    template: { require: `text!/Themes/Default/Content/ts/Shared/ClubSelector/${componentName}.html` }
});